// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9de14d7","455":"d12ffc51","457":"01f754cf","828":"f3bcaae8","851":"a82669f0","977":"0e2027d8"}[chunkId] + ".chunk.js";
};